// TODO TUB-7556
//  * remove when special dhl-at return-handling for dhl was completly removed ... remember the return page ... there this logic is still required ...
//  * RENAME FILE
/**
 * Account forms: orders,...
 *
 * Functions concerning the Order Return Page
 */
function init() {
	initReturnHandling();
}

function initReturnHandling() {
	$("body").on("click", ".js-returnform", function () {
		const $orderOptions = $(this).closest(".js-order-details");
		const firstName = $orderOptions.find('input[returnform="firstName"]').val();
		const lastName = $orderOptions.find('input[returnform="lastName"]').val();
		const street = $orderOptions.find('input[returnform="street"]').val();
		const streetNumber = $orderOptions.find('input[returnform="streetNumber"]').val();
		const postalCode = $orderOptions.find('input[returnform="postalCode"]').val();
		const town = $orderOptions.find('input[returnform="town"]').val();
		const orderId = $orderOptions.find('input[returnform="orderId"]').val();
		const baseUrl = $orderOptions.find('input[returnform="returnBaseUrl"]').val();

		const url = `${baseUrl}&LOCALE=DE&ADDR_SEND_STREET_ADD=${orderId}&ADDR_SEND_FIRST_NAME=${escape(
			firstName
		)}&ADDR_SEND_LAST_NAME=${escape(lastName)}&ADDR_SEND_STREET=${escape(
			`${street} ${streetNumber}`
		)}&ADDR_SEND_ZIP=${postalCode}&ADDR_SEND_CITY=${escape(town)}`;

		let height = 725;
		let width = 1010;
		if (screen && screen.availHeight < height) {
			height = screen.availHeight;
		}
		if (screen && screen.availWidth < width) {
			width = screen.availWidth;
		}

		const newWindow = window.open(url, "popupwindow", `height=${height},width=${width},resizable=1,scrollbars=1`);
		if (window.focus) {
			newWindow.focus();
		}
	});
}

export { init };
